<template>
    <div class="person">
        <navbar :isHiddenlogin="false"></navbar>
        <div class="person-page">
            <Sidebar />
            <div class="person-content">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/sidebar.vue'
import navbar from '@/components/nav.vue'
export default {
    name: "PersonIndex",
    components: { Sidebar, navbar }
}
</script>

<style scoped>
.person{
    width: var(--main-width);
    margin: 0 auto;
}
.person-page {
    display: flex;
}

.person-content {
    flex: 1;
    /* padding:0 20px; */
    padding-left: 60px;
}
</style>